<template>
  <v-container fluid>
    <v-layout align-baseline>
      <v-flex>
        <v-btn color="primary" @click="openAddPopup">{{ $t('add') }}</v-btn>
      </v-flex>
      <v-flex sm3 md3 lg2>
        <v-text-field append-icon="search" :label="$t('search')" single-line hide-details v-model="filter"
          clearable></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table :headers="headers"
    :pagination.sync="pagination" item-key="id" :rowsPerPageItems="rowsPerPageItems"
    :items="list" :search="filter" class="elevation-1">
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.businessType }}
        </td>
        <td class="text-xs-left">
          {{ props.item.source }}
        </td>
        <td class="text-xs-left">
          {{ props.item.files[0].name }}
        </td>
        <td class="text-xs-left">
          {{ props.item.note }}
        </td>
      </template>
    </v-data-table>

    <FormSubmitPopup v-if="isShowPopup" :title="popupTitle" v-model="isShowPopup" @popupClose="closePopup"
      :rightMethod="saveResource" hasAlert medium>
      <template v-slot:input>
        <v-layout justify-start align-baseline>
          <v-flex xl12>
            <UploadFileWidget
              v-model="currentFile.files"
              ref="fileUploader"
              :maxFiles="1"
              type="ThirdWMS"
              :sizeLimit="5242880 * 4"
              :clearFiles="clearFiles"
              iconType="cloud_upload"
              :loading="loading"
              :acceptTypes="['.xlsx', '.xls']"
            >
              {{ $t('uploadExcel') }}({{ currentFile.files.length }})
          </UploadFileWidget>
          </v-flex>
        </v-layout>
        <v-layout justify-start align-baseline>
          <v-flex>
            <v-select :items="typeOptions" v-model="currentFile.businessType" :label="$t('businessType')"></v-select>
          </v-flex>
          <v-flex>
            <v-select :items="sourceOptions" v-model="currentFile.source" :label="$t('source')"></v-select>
          </v-flex>
          <v-flex v-if="currentFile.source === 'EC_WMS'">
            <v-select :items="warehouseOptions" v-model="currentFile.warehouseKey" :label="$t('warehouse')"></v-select>
          </v-flex>
        </v-layout>
        <v-layout justify-start align-baseline>
          <v-flex>
            <v-textarea
            :label="$t('note')"
            outline
            v-model="currentFile.note"></v-textarea>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from '@/components/FormSubmitPopup'
import { checkRules } from '@/utils/tools'
import UploadFileWidget from '@/components/UploadFileWidget'
import xlsx from 'xlsx'

export default {
  name: 'ImportResource',
  components: {
    FormSubmitPopup,
    UploadFileWidget
  },
  mixins: [checkRules],
  data () {
    return {
      filter: '',
      isShowPopup: false,
      popupTitle: '',
      currentFile: {},
      pagination: {
        sortBy: 'createTime',
        descending: true,
        rowsPerPage: 25
      },
      rowsPerPageItems: [25, 50, 100, {text: this.$t('all'), value: -1}],
      loading: false,
      clearFiles: true,
      typeOptions: [
        { text: this.$t('inbound'), value: 'INBOUND' },
        { text: this.$t('outbound'), value: 'OUTBOUND' }
      ],
      sourceOptions: [
        { text: '领星', value: 'LINGXING' },
        { text: '易仓', value: 'EC_WMS' }
      ],
      businessType: 'INBOUND',
      source: 'LINGXING',
      warehouseOptions: [{
        text: '美东1仓(英莱特)',
        value: '美东1仓(英莱特)'
      }, {
        text: '美东1仓(捷宝)',
        value: '美东1仓(捷宝)'
      }],
      warehouseKey: null
    }
  },
  async mounted () {
    if (this.$store.getters.thirdPartyResources.length === 0) {
      await this.getList()
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('businessType'), value: 'businessType' },
        { text: this.$t('source'), value: 'source' },
        { text: this.$t('file'), value: 'file' },
        { text: this.$t('note'), value: 'note' }
      ]
    },
    list () {
      return this.$store.getters.thirdPartyResources
    }
  },
  methods: {
    getList () {
      return this.$store.dispatch('getThirdPartyResources')
    },
    openAddPopup () {
      this.popupTitle = this.$t('importResource')
      this.currentFile = { files: [], note: '', businessType: this.businessType, source: this.source, warehouseKey: this.warehouseKey }
      this.isShowPopup = true
    },
    closePopup () {
      this.currentFile = {}
      this.isShowPopup = false
    },
    async readFile (files) {
      if (!files) return
      const file = files[0]
      let reader = new FileReader()

      reader.readAsBinaryString(file)
      const result = await new Promise((resolve, reject) => {
        reader.onload = async e => {
          let fileData = e.target.result
          const workbook = xlsx.read(fileData, { type: 'binary' })
          const sheetNames = workbook.SheetNames
          let rawData = xlsx.utils.sheet_to_json(workbook.Sheets[sheetNames[0]])
          resolve({rawData, sheetNames})
        }
      })
      return result
    },
    validateFormat (data, sheetNames) {
      if (data.length === 0) {
        throw new Error(this.$t('pleaseUploadFile'))
      }
      if (this.currentFile.source === 'LINGXING') {
        if (this.currentFile.businessType === 'INBOUND') {
          this.validateInboundInLX(data, sheetNames)
        } else if (this.currentFile.businessType === 'OUTBOUND') {
          this.validateOutboundInLX(data, sheetNames)
        }
      } else if (this.currentFile.source === 'EC_WMS') {
        if (this.currentFile.businessType === 'INBOUND') {
          this.validateInboundInEC_WMS(data, sheetNames)
        } else if (this.currentFile.businessType === 'OUTBOUND') {
          this.validateOutboundInEC_WMS(data, sheetNames)
        }
      }
      return data
    },
    validateOutboundInLX (data, sheetNames) {
      const requiredHeaders = [
        'Warehouse/仓库',
        'Client/客户',
        'Outbound Order No/出库单号',
        'Pick time/拣货时间',
        'OutboundTime/出库时间',
        'SKU',
        'Product Name/产品名称',
        'Outbound Qty/出库数量'
      ]
      const isHasHeader = requiredHeaders.every(header => data[0][header])
      if (!isHasHeader) {
        throw new Error('import outbound 必填字段缺失')
      }
      return true
    },
    validateInboundInEC_WMS (data, sheetNames) {
      const requiredHeaders = [
        '入库单号',
        'sku',
        '客户代码',
        '上架数量',
        '上架时间'
      ]

      // {
      //   "入库单号": "RSO2505300004",
      //   sku: "RYMY208-9WJGDB-01",
      //   "客户代码": "RYMY208",
      //   "上架数量": "100",
      //   "库位号": "0-1-1",
      //   "上架时间": "2025-07-02 03:11:36",
      //   "收货类型": "中转",
      //   "上架操作员": "美东1仓",
      //   "收货时间": "2025-07-02 03:10:30",
      //   "收货操作员": "美东1仓",
      //   "跟踪号": "TSO2505290002",
      //   "上架类型": "常规上架",
      // }
      const isHasHeader = requiredHeaders.every(header => data[0][header])
      if (!isHasHeader) {
        throw new Error('易仓入库单必填字段缺失')
      }
      return true
    },
    validateOutboundInEC_WMS (data, sheetNames) {
      const requiredHeaders = [
        'Warehouse/仓库',
        'Client/客户',
        'Outbound Order No/出库单号',
        'Pick time/拣货时间',
        'OutboundTime/出库时间',
        'order_product_code',
        'order_quantity',
        'order_product_name'  
      ]

      const isDataRequired = requiredHeaders.every(header => data[0][header])
      if (!isDataRequired) {
        throw new Error('易仓出库单必填字段缺失')
      }
      return true
    },
    validateInboundInLX (data, sheetNames) {
      const onePieceInbound = 'one-piece'
      const FBAInbound = 'FBA-Inbound'

      const onePieceInboundSheet = ['一件代发入库单（按箱唛）', '备货中转入库单']
      const FBAInboundSheet = ['Sheet1']
      const FBAHeaders = [
        'Warehouse/仓库',
        'Client/客户',
        'Removal inbound No./退货入库单号',
        'Removal inbound task order/退货入库任务单号',
        'Status/状态',
        'Tracking No./物流跟踪号',
        'Shipping carrier/物流承运商',
        'Number of returned goods/预报退件数量',
        'Signing time/签收时间',
        'Receiving time/收货时间',
        'Putaway time/上架时间',
        'FNSKU',
        'SKU',
        'Product Name/产品名称'
      ]
      const isFBAHeaders = FBAHeaders.every(header => data[0][header])
      const isOnePieceInbound = onePieceInboundSheet.some(sheetName => sheetNames.includes(sheetName))
      const isFBAInbound = FBAInboundSheet.some(sheetName => sheetNames.includes(sheetName)) && isFBAHeaders
      if (isOnePieceInbound) {
        return onePieceInbound
      } else if (isFBAInbound) {
        return FBAInbound
      }
      throw new Error('异常的文件格式, 缺少必要的字段')
    },
    async saveResource () {
      if (this.currentFile.files.length === 0) {
        throw new Error(this.$t('pleaseUploadFile'))
      }
      const files = this.$refs.fileUploader.$$getRawFiles()
      const {rawData, sheetNames} = await this.readFile(files)
      this.validateFormat(rawData, sheetNames)
      const prompt = window.prompt('Please input code')
      if (prompt === null) {
        throw new Error('Invalid password')
      }
      if (prompt !== 'viteusa123') {
        throw new Error('Invalid password')
      }
      const newPacking = { ...this.currentFile }
      if (this.currentFile.source === 'EC_WMS') {
        newPacking.warehouseKey = this.currentFile.warehouseKey
      }
      return this.$store.dispatch('saveThirdPartyResources', newPacking)
        .then(() => {
          this.closePopup()
        })
        .catch(error => {
          console.error('save failed:', error)
          throw error
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ImportResource.vue